import { render, staticRenderFns } from "./safeWithdrawalHistory.vue?vue&type=template&id=16aa5c83"
import script from "./safeWithdrawalHistory.vue?vue&type=script&lang=js"
export * from "./safeWithdrawalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports